import { SxProps } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { styles } from './PublicationViewLoadingSkeleton.styles';

const widths = ['60%', '80%', '70%', '90%', '65%'];

export function PublicationViewLoadingSkeleton({ sx = {} }: { sx?: SxProps }) {
  return (
    <TableContainer data-test="publication-view-loading-skeleton" sx={{ width: '100%', ...sx }}>
      {Array.from({ length: 10 }, (_, index) => (
        <TableRow key={`skeleton-${index}`}>
          <TableCell sx={styles.checkboxCell}>
            <Skeleton variant="rectangular" width={24} height={24} />
          </TableCell>
          <TableCell sx={styles.cell}>
            <Skeleton variant="text" width={widths[index % widths.length]} height={32} />
          </TableCell>
          <TableCell sx={styles.cell}>
            <Skeleton variant="text" width={widths[(index + 1) % widths.length]} height={32} />
          </TableCell>
          <TableCell sx={styles.cell}>
            <Skeleton variant="text" width={widths[(index + 2) % widths.length]} height={32} />
          </TableCell>
          <TableCell sx={styles.cell}>
            <Skeleton variant="text" width={widths[(index + 3) % widths.length]} height={32} />
          </TableCell>
        </TableRow>
      ))}
    </TableContainer>
  );
}
